import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject, takeUntil } from 'rxjs';

import { SnackBarConfig } from 'v2/modules/shared/configs/snackbar.config';

// SERVICES
import { OrderSalesApiService } from 'v2/modules/shared/services/api/order/order-sales-api.service';
import { LoadingDialogUtilService } from 'v2/modules/shared/services/util/loading-dialog-util.service';

// UTILS
import { trackById } from 'v2/modules/shared/util/track-by.util';

@Component({
  selector: 'lum-ui-fulfillment-action-confirmation-dialog',
  templateUrl: './ui-fulfillment-action-confirmation-dialog.component.html',
  styleUrls: ['./ui-fulfillment-action-confirmation-dialog.component.scss'],
})
export class UiFulfillmentActionConfirmationDialogComponent {
  trackById = trackById;
  private onDestroy$ = new Subject<void>();
  constructor(
    public dialogRef :MatDialogRef<UiFulfillmentActionConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data :{
      title :string;
      message :string;
      inputType ?:string;
      inputLabel ?:string;
      fulfillmentConfirmationValues ?:any;
    },
    private orderSalesApiService :OrderSalesApiService,
    private snackBar :MatSnackBar,
    private loadingDialogService :LoadingDialogUtilService,
  ) {}

  onNoClick() :void {
    this.dialogRef.close(false);
  }

  onYesClick() :void {
    this.dialogRef.close(true);
  }
}
